'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ResponsivePie } from '@nivo/pie';
import { PieChartText } from './components/PieChartText';
import { Tooltip } from './components/Tooltip';
export const PieChart = ({ title, description, data, theme = 'dark' }) => {
    const ChartText = useMemo(() => ({ centerX, centerY }) => (_jsx(PieChartText, { centerX: centerX, centerY: centerY, title: title, description: description, theme: theme })), [title, description, theme]);
    return (_jsx(ResponsivePie, { colors: { datum: 'data.color' }, data: data, innerRadius: 0.8, padAngle: 1, enableArcLinkLabels: false, enableArcLabels: false, defs: [], fill: [], legends: [], layers: ['arcs', ChartText], tooltip: ({ datum }) => _jsx(Tooltip, { datum: datum }) }));
};
